var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":"","wrap":"","id":"salesforce"}},[_c('v-flex',{attrs:{"md6":"","xs6":""}},[_c('SalesforceReexport')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }